import { RequestFactory, setDefaultFactory } from './RequestFactory';
import queryString = require('query-string');
import { apiUrl } from './config';

function configureApi() {
    const factory = new RequestFactory(`${apiUrl}/2`);
    // const factory = new RequestFactory('http://localhost:8080/2');
    // const factory = new RequestFactory('http://localhost:7070/2');
    // factory.setApiKey('957cab62-a9ae-4dac-be55-c9a6008befee');
    // factory.setApiKey('7260f2e0-7f59-11e3-b46a-d79b27037c97');

    const apiKey = queryString.parse(location.search).apiKey;

    if(apiKey) {
        factory.setApiKey(apiKey);
    }

    setDefaultFactory(factory);
}

export default configureApi;


// WEBPACK FOOTER //
// ./src/api/configureApi.ts